import { render, staticRenderFns } from "./base-header.vue?vue&type=template&id=9d00bbfa&"
import script from "./base-header.vue?vue&type=script&lang=ts&"
export * from "./base-header.vue?vue&type=script&lang=ts&"
import style0 from "./base-header.vue?vue&type=style&index=0&id=9d00bbfa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports